import React, { useEffect, useState } from 'react';
import { oneOfType, string, number } from 'prop-types';
import { QueryProvider } from '@thd-nucleus/data-sources';
import { useThdCustomer } from '@thd-olt-functional/customer-information';
import { Directory } from './Directory';

export const DirectoryContainer = ({ timeout, ...props }) => {
  const { isCustomerIdentified = false } = useThdCustomer();
  const [isMounted, setIsMounted] = useState(false)

  useEffect(() => {
    setIsMounted(true)
  }, [])

  const defaultVariables = {
    isBrandPricingPolicyCompliant: isMounted ? isCustomerIdentified : false,
  }

  return (
    <QueryProvider defaultVariables={defaultVariables} cacheKey="store-directory">
      {/* eslint-disable-next-line react/jsx-props-no-spreading */}
      <Directory />
    </QueryProvider>
  );
};

DirectoryContainer.propTypes = {
  timeout: oneOfType([string, number])
};

DirectoryContainer.defaultProps = {
  timeout: '3000'
};
